/**
 * @Description 益禾堂预估销售额详情
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132271748
 */

import { FC } from 'react';
import { Col } from 'antd';
// import {
//   estimateSalesReasonableSelectYHT,
//   estimateSalesSafetySelectYHT,
//   estimateSalesUpLimitSelectYHT,
//   estimateSalesUpLimitYHT,
//   insiderEstimateSalesYHT,
//   meituanCompetitorAverageYHT,
//   meituanCompetitorMaxYHT,
// } from '@/common/components/business/DynamicComponent/config';
// import { isArray, isNotEmpty } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';


const PopulationFlowYHTDetail: FC<any> = ({
  propertyItem,
  textValue
}) => {
  const methods = useMethods({
    getShowVal: () => {
      const { options, value } = textValue || {};
      if (isArray(options) && options.length) {
        const targetOption = options.find((item) => item.value === value);
        return targetOption?.label || '-';
      }
      return '-';
    }
  });
  return (

    <Col span={12}>
      <V2DetailItem
        label={textValue?.label || propertyItem?.anotherName || propertyItem?.name || '人口流量'}
        value={methods.getShowVal()}
      />
    </Col>

  );
};

export default PopulationFlowYHTDetail;
